<template>
  <div class="absolute inset-0">
    <div v-for="n in 5" :key="`ring-${n}`" class="vaah-why-ring" :class="`vaah-why-ring-${n}`">
      <span class="vaah-why-shimmer"></span>
    </div>
    <div v-for="arc in ['outer', 'mid']" :key="`arc-${arc}`" class="vaah-why-arc" :class="`vaah-why-arc-${arc}`">
      <span class="vaah-why-arc-glow"></span>
      <span class="vaah-why-arc-line"></span>
    </div>
  </div>
</template>

<style scoped>
/* Concentric Dashed Ring Insets */
.vaah-why-ring {
  position: absolute;
  border: 1px dashed rgba(84, 101, 148, 0.35);
  border-radius: 50%;
}
.vaah-why-ring-1 { inset: 0; }
.vaah-why-ring-2 { inset: 8.5%; }
.vaah-why-ring-3 { inset: 16.5%; }
.vaah-why-ring-4 { inset: 24.6%; }
.vaah-why-ring-5 { inset: 33%; }

/* Conic Shimmers & Rotating Gradient Arcs */
.vaah-why-shimmer {
  position: absolute;
  inset: 0;
  border-radius: 50%;
  background: conic-gradient(from 0deg, transparent 0deg, #bdc5ff 40deg, transparent 90deg);
  -webkit-mask: radial-gradient(farthest-side, transparent calc(100% - 3px), #000 calc(100% - 1px));
  mask: radial-gradient(farthest-side, transparent calc(100% - 3px), #000 calc(100% - 1px));
  animation: vaah-why-spin 10s linear infinite reverse;
}

.vaah-why-arc {
  position: absolute;
  border-radius: 50%;
  animation: vaah-why-spin 14s linear infinite;
}
.vaah-why-arc-outer { inset: 0; }
.vaah-why-arc-mid { inset: 8.5%; animation-duration: 18s; animation-direction: reverse; }

.vaah-why-arc-glow,
.vaah-why-arc-line {
  position: absolute;
  inset: 0;
  border-radius: 50%;
}

.vaah-why-arc-glow {
  padding: 2px;
  background: conic-gradient(from 0deg, transparent 0deg, #4b4fd6 40deg, #3337af 80deg, transparent 120deg);
  -webkit-mask: radial-gradient(farthest-side, transparent calc(100% - 4px), #000 calc(100% - 3px));
  mask: radial-gradient(farthest-side, transparent calc(100% - 4px), #000 calc(100% - 3px));
  filter: blur(10px);
  opacity: 0.85;
}

.vaah-why-arc-line {
  padding: 1px;
  background: conic-gradient(from 0deg, transparent 0deg, transparent 30deg, #a5acff 55deg, #6b74f0 75deg, transparent 110deg);
  -webkit-mask: radial-gradient(farthest-side, transparent calc(100% - 2.5px), #000 calc(100% - 1.5px));
  mask: radial-gradient(farthest-side, transparent calc(100% - 2.5px), #000 calc(100% - 1.5px));
}

@keyframes vaah-why-spin {
  to { transform: rotate(360deg); }
}

/* Light Theme Overrides */
.my-app-light .vaah-why-shimmer {
  background: conic-gradient(from 0deg, transparent 0deg, #8b7bff 40deg, transparent 90deg);
}

@media (prefers-reduced-motion: reduce) {
  .vaah-why-arc, .vaah-why-shimmer {
    animation: none;
  }
}
</style>
